<agr-dialog (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <div class="spacing--margin-half-bottom flex--row flex--wrap">
      {{ 'link-slaughter-invoices-description' | translate }}
    </div>
    <mat-card
      appearance="outlined"
      *ngFor="let invoice of data.slaughterInvoices"
      [attr.data-test]="'slaughter-invoice__' + invoice.id"
      class="mat-elevation-z spacing--margin-half-bottom"
    >
      <mat-card-content class="slaughter-invoice-import__row-item">
        <div class="flex--column field-width">
          <mat-checkbox
            [attr.data-test]="'slaughter-invoice-select__' + invoice.id"
            [ngModel]="true"
            (change)="updateInvoiceSelection($event, invoice.id)"
            >{{ 'slaughter-invoice' | translate }} {{ invoice.invoiceDate | agrDate }}
          </mat-checkbox>
        </div>
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label"> {{ 'invoice-number' | translate }} </span>
          <span class="text--small text--bold label">
            {{ invoice.invoiceId }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label">
            {{ 'amount-excluding-vat' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ invoice.amount }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label"> {{ 'vat' | translate }} </span>
          <span class="text--small text--bold label">
            {{ invoice.vatPercentage }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label">
            {{ 'amount-including-vat' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ invoice.amountIncludingVat }}
          </span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</agr-dialog>
